import { getBusinessRegistrations } from "./root";

export const getBusinessRegistrationById =
  (registrationId: string | null | undefined) => (state: RootState) =>
    (registrationId && getBusinessRegistrations(state)[registrationId]) || null;
